import { makeDecodeURL } from '../../../shared/helpers/makeDecodeURL';

function extractFilenameFromUrl(url: string): string | null {
    const urlParts = url.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    return lastPart ? decodeURIComponent(lastPart.split('?')[0]) : null;
}

export const saveFile = async (url: string): Promise<void> => {
    try {
        //@ts-ignore
        await loader.show();

        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(i18next.t('saveFile.response.Error'));
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = extractFilenameFromUrl(url) || 'downloaded_file_name.ext';

        filename = makeDecodeURL(filename, true);

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1];
            }
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.style.display = 'none';
        anchor.href = objectUrl;
        anchor.download = filename;

        document.body.appendChild(anchor);
        anchor.click();

        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(anchor);
        //@ts-ignore
        await loader.hide();
    } catch (error) {
        //@ts-ignore
        swal({
            text: i18next.t('saveFile.response.Error'),
            buttons: {
                confirm: {
                    text: i18next.t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-light',
                },
            },
        });

        //@ts-ignore
        loader.hide();
    }
};
